import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { TextPairing } from '@components/TextPairing';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import styled from 'styled-components';

const PAGE_MAX_WIDTH = '1200px';

export const StyledSection = styled(Flex)`
  padding: ${themeSpace(8)} ${themeSpace(7)};
  justify-content: center;
  flex-direction: column;
  gap: ${themeSpace(9)};
  ${themeMediaQuery('md')} {
    padding: ${themeSpace(8)} ${themeSpace(12)};
  }
  ${themeMediaQuery('lg')} {
    max-width: ${PAGE_MAX_WIDTH};
    width: 100%;
    padding: ${themeSpace(8)} 0;
  }
`;

export const StyledTextPairing = styled(TextPairing)``;

export const StyledGridContainer = styled(Box)`
  display: grid;
  grid-gap: ${themeSpace(6)};
  grid-template-rows: 1fr 1fr;
  ${themeMediaQuery('md')} {
    grid-template-columns: 3fr 2fr;
    grid-template-rows: unset;
  }
`;

export const StyledCardWrapper = styled(Box)`
  display: grid;
  grid-template-rows: 1fr 1fr;
  grid-gap: ${themeSpace(6)};
`;
